var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 33.7119H27.4734V6.28124H34.625V33.7119ZM23.703 33.7119H18.6296V6.28124H23.703V33.7119ZM15.2674 33.7119H11.3771V6.28124H15.2674V33.7119ZM8.15814 33.7119H5.375V6.28124H8.15814V33.7119Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInference);
export default __webpack_public_path__ + "static/media/inference.55258a29897fb541ea9549236d5ae6cc.svg";
export { ForwardRef as ReactComponent };